export const municipalityFrag = `
    id
    code
    name
`;
